import { on } from "~/javascript/lib/delegator";
// back history button
on("click", ".back-history-link", (e) => {
  e.preventDefault();
  window.history.back();
});
